import { $http } from '@/utils/https'

const statuses = {
  active: 'active',
  disabled: 'disabled'
}

export default {
  name: 'ReviewPage',
  data () {
    return {
      review: null,
      loading: false,
      btnLoading: false,
      statuses
    }
  },
  computed: {
    reviewId () {
      return +this.$route.params.id
    }
  },
  async created () {
    await this.getReview()
  },
  methods: {
    async getReview () {
      try {
        this.loading = true
        const { data: { data } } = await $http.get(`${process.env.VUE_APP_ROOT_COURSE}ratings/${this.reviewId}`, {
          params: {
            include: 'user.personalData,material.module,material.course'
          }
        })
        this.review = data
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    },
    async disableReview () {
      try {
        this.btnLoading = true
        await $http.post(`${process.env.VUE_APP_ROOT_COURSE}ratings/${this.reviewId}/disable`, {
          _method: 'patch'
        })
        await this.getReview()
      } catch (e) {
        console.log(e)
      } finally {
        this.btnLoading = false
      }
    }
  }
}
